import {Connection, Edge} from 'reactflow';

import {ProcedureEdgeType} from 'procedures/ProcedureDomainTypes';

import {getHandleType, getHandleTypeDetails, ProcedureHandleObjectType} from './handleIdentifierUtils';
import {ProcedureValidationError} from './validation/ProcedureValidationTypes';
import {filterProcedureValidationErrors} from './validation/procedureValidationUtils';

export function isValidConnection(connection: Connection, handlesInUse: Array<string>): boolean {
  const sourceDetails = getHandleTypeDetails(connection.sourceHandle!);
  const targetDetails = getHandleTypeDetails(connection.targetHandle!);
  const isSourceSameTypeAsTarget = sourceDetails.procedureHandleType === targetDetails.procedureHandleType;

  return (
    connection.targetHandle != null &&
    !handlesInUse.includes(connection.targetHandle) &&
    isSourceSameTypeAsTarget
  );
}

export function isHandleConnectedToInvalidMaterialEdge(
  handleId: string,
  edges: Array<Edge>,
  procedureValidationErrors: Array<ProcedureValidationError>
): boolean {
  if (getHandleType(handleId) !== ProcedureHandleObjectType.MATERIAL) {
    return false;
  }
  return (
    edges
      .filter(
        (edge) =>
          edge.type === ProcedureEdgeType.MATERIAL_EDGE &&
          (edge.sourceHandle === handleId || edge.targetHandle === handleId)
      )
      .find(
        (edge) =>
          filterProcedureValidationErrors(procedureValidationErrors, {
            primaryObjectId: edge.id,
          }).length > 0
      ) != null
  );
}
